// extracted by mini-css-extract-plugin
module.exports =  {"columns":"ibq407r95iRcRvklWIq0","content":"ze2l22JxyX2870J3E1Xi"};